/* © CNES */
import moment from 'moment';
import { filterSections } from '../../../../../assets/config/filters/Referenciel';
import { CustomAccordion } from '../../../../shared/Accordion/CustomAccordion';
import { InnerWhen } from './InnerWhen/InnerWhen';

/**
 * WhenCondition displays When filter section.
 * @param handleChange Function to handle when dates are selected by user.
 * @returns WhenCondition Element.
 */
export const WhenCondition = ({
  handleChange,
}: {
  handleChange: (e: any, key: string) => void;
}) => {
  /**
   * onChangeDate
   * @param value time
   * @param key key on which time change.
   */
  const onChangeDate = (value: Date, key: string) => {
    handleChange(moment(value).utcOffset(0, true).toISOString(), key);
  };

  return (
    <div className="filterWhen">
      <CustomAccordion
        title={filterSections.startDate.title}
        children={<InnerWhen onChangeDate={onChangeDate} />}
      />
    </div>
  );
};
